import { Card, Form, Input, Typography } from 'antd';

export interface SeoState {
  metaTitle?: string;
  metaDescription?: string;
  canonical?: string;
  focusKeyword?: string;
}

interface Props {
  value: SeoState;
  onChange: (next: SeoState) => void;
  fallbackTitle: string;
  /** OG 圖自動跟封面走（不手動填）。 */
  coverUrl?: string | null;
}

/** SEO 設定 + 分享預覽（OG 圖＝封面）。 */
export default function SeoPanel({ value, onChange, fallbackTitle, coverUrl }: Props) {
  const set = (k: keyof SeoState) => (e: { target: { value: string } }) =>
    onChange({ ...value, [k]: e.target.value });

  const ogTitle = value.metaTitle || fallbackTitle;
  const ogDesc = value.metaDescription || '';

  return (
    <Card title="SEO / 社群分享">
      <Form layout="vertical">
        <Form.Item label="SEO 標題（meta title）" className="!mb-3">
          <Input.TextArea
            autoSize={{ minRows: 1 }}
            value={value.metaTitle}
            onChange={set('metaTitle')}
            placeholder={fallbackTitle}
          />
        </Form.Item>
        <Form.Item label="SEO 描述（meta description）" className="!mb-3">
          <Input.TextArea
            autoSize={{ minRows: 3 }}
            value={value.metaDescription}
            onChange={set('metaDescription')}
          />
        </Form.Item>
        <Form.Item label="焦點關鍵字" className="!mb-1">
          <Input.TextArea
            autoSize={{ minRows: 1 }}
            value={value.focusKeyword}
            onChange={set('focusKeyword')}
          />
        </Form.Item>
      </Form>

      <Typography.Text type="secondary" className="text-xs">
        分享預覽（FB / LINE，OG 圖＝封面）
      </Typography.Text>
      <div className="mt-1 overflow-hidden rounded-md border">
        {coverUrl ? (
          <img src={coverUrl} alt="og" className="h-32 w-full object-cover" />
        ) : (
          <div className="flex h-32 items-center justify-center bg-gray-100 text-gray-400">
            尚未設定封面
          </div>
        )}
        <div className="p-2">
          <div className="truncate text-sm font-medium">{ogTitle}</div>
          <div className="line-clamp-2 text-xs text-gray-500">{ogDesc || '（無描述）'}</div>
          <div className="mt-1 text-xs uppercase text-gray-400">nagoya-cat.tw</div>
        </div>
      </div>
    </Card>
  );
}
